module.exports = __webpack_public_path__ + "static/media/trimex_yoreda.ef97f130.png";